module.exports = __webpack_public_path__ + "img/2025-01.98fa8bee.jpg";